import { Switch, Route, withRouter } from 'react-router-dom';
import { AccessDenied } from 'ui/shared/AccessDenied';
import { Permission } from 'shared/permissions';
import { useSession } from 'hooks';
import { SetupPage } from '../setupPage/SetupPage';

export const SetupRouter = withRouter(() => {
    const { hasPermission } = useSession();
    if (!hasPermission(null, Permission.EditBuilding, Permission.EditDevice)) {
        return <AccessDenied/>;
    }
    return (
        <Switch>
            <Route path="" component={ SetupPage }/>
        </Switch>
    );
});
